export const List = () => import("./List.vue");
export const OutList = () => import("./OutList.vue");
export const Create = () => import("./Create.vue");
export const BulkCreate = () => import("./BulkCreate.vue");
export const BulkEntry = () => import("./BulkEntry.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const Calendar = () => import("./Calendar.vue");
export const LeaveApproved = () => import("./LeaveApproved.vue");
